import { motion } from "framer-motion";
import Footer from "../components/Footer";

function LegalLayout({ overline, title, updated, children, testId }) {
  return (
    <main className="pt-20 min-h-screen" data-testid={testId}>
      <div className="max-w-3xl mx-auto px-6 md:px-12 pt-16 md:pt-24">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="overline-label mb-5">{overline}</p>
          <h1 className="font-serif font-light text-4xl md:text-5xl mb-4">{title}</h1>
          <p className="text-xs text-muted-foreground tracking-wide mb-14">
            Ultimo aggiornamento: {updated}
          </p>
          <div className="space-y-10 text-muted-foreground leading-relaxed tracking-wide text-sm md:text-base [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:font-light [&_h2]:text-foreground [&_h2]:mb-3 [&_a]:text-primary">
            {children}
          </div>
          <p className="mt-16 pt-8 border-t border-white/10 text-xs text-muted-foreground/70 tracking-wide leading-relaxed" data-testid={`${testId}-titolare`}>
            Titolare: AB fëlise shop, Via Mare 62, 89030 Condofuri (RC) — P.IVA 03383950809 — email:{" "}
            <a href="mailto:ordini@abfeliseshop.it" className="text-primary">ordini@abfeliseshop.it</a>
          </p>
        </motion.div>
      </div>
      <Footer />
    </main>
  );
}

const TITOLARE = (
  <>
    AB fëlise shop · Via Mare, 62 — 89030 Condofuri (RC) · P.IVA 03383950809 ·{" "}
    <a href="mailto:ordini@abfeliseshop.it">ordini@abfeliseshop.it</a>
  </>
);

export function PrivacyPolicy() {
  return (
    <LegalLayout overline="Documenti legali" title="Privacy Policy" updated="ottobre 2026" testId="privacy-page">
      <section>
        <h2>1. Titolare del trattamento</h2>
        <p>{TITOLARE}</p>
      </section>
      <section>
        <h2>2. Dati che raccogliamo</h2>
        <p>
          Dati dell'ordine (nome, email, indirizzo di consegna), dati dell'account se ti registri
          (nome, email, password protetta) e dati di pagamento, trattati direttamente da Stripe:
          noi non vediamo né conserviamo mai il numero della tua carta.
        </p>
      </section>
      <section>
        <h2>3. Perché li usiamo</h2>
        <p>
          Per evadere il tuo ordine e spedirlo (esecuzione del contratto), inviarti la conferma
          d'ordine via email, gestire il tuo account e adempiere agli obblighi fiscali e contabili
          previsti dalla legge.
        </p>
      </section>
      <section>
        <h2>4. Chi li tratta</h2>
        <p>
          Stripe (pagamenti, con sede UE/USA secondo le clausole contrattuali standard), il nostro
          fornitore di hosting e il vettore di spedizione. Non vendiamo né cediamo i tuoi dati
          a terzi per marketing.
        </p>
      </section>
      <section>
        <h2>5. Conservazione</h2>
        <p>
          I dati dell'ordine sono conservati per 10 anni (obblighi fiscali); quelli dell'account
          finché resti registrato. Puoi chiedere la cancellazione in qualsiasi momento.
        </p>
      </section>
      <section>
        <h2>6. I tuoi diritti</h2>
        <p>
          Hai diritto di accesso, rettifica, cancellazione, limitazione e portabilità dei dati
          (artt. 15-20 GDPR). Scrivici a{" "}
          <a href="mailto:info@abfeliseshop.it">info@abfeliseshop.it</a> — rispondiamo entro 30
          giorni. Puoi proporre reclamo al Garante per la protezione dei dati personali.
        </p>
      </section>
    </LegalLayout>
  );
}

export function CookiePolicy() {
  return (
    <LegalLayout overline="Documenti legali" title="Cookie Policy" updated="ottobre 2026" testId="cookie-page">
      <section>
        <h2>1. Cosa usiamo</h2>
        <p>
          Questo sito utilizza esclusivamente <strong>cookie tecnici</strong>, necessari al
          funzionamento: il cookie di sessione che ti tiene connesso al tuo account e la memoria
          locale del browser per il carrello.
        </p>
      </section>
      <section>
        <h2>2. Cookie di Stripe</h2>
        <p>
          Durante il pagamento, Stripe può impostare cookie propri per la prevenzione delle frodi.
          Sono necessari alla sicurezza della transazione e non vengono usati per profilarti qui.
        </p>
      </section>
      <section>
        <h2>3. Cosa NON usiamo</h2>
        <p>
          Nessun cookie di profilazione, nessun pixel pubblicitario, nessun tracciamento
          di terze parti a fini marketing.
        </p>
      </section>
      <section>
        <h2>4. Come gestirli</h2>
        <p>
          Puoi cancellare o bloccare i cookie dalle impostazioni del tuo browser. Bloccare i
          cookie tecnici può impedire il login e il corretto funzionamento del carrello.
        </p>
      </section>
    </LegalLayout>
  );
}

export function Terms() {
  return (
    <LegalLayout overline="Documenti legali" title="Condizioni di vendita" updated="ottobre 2026" testId="terms-page">
      <section>
        <h2>1. Venditore</h2>
        <p>{TITOLARE}</p>
      </section>
      <section>
        <h2>2. Prezzi e pagamento</h2>
        <p>
          Tutti i prezzi sono in euro e includono l'IVA. Il pagamento avviene in modo sicuro
          tramite Stripe — carta, Apple Pay, Google Pay, Klarna o Scalapay. L'ordine è confermato
          al ricevimento del pagamento, con email di riepilogo automatica.
        </p>
      </section>
      <section>
        <h2>3. Spedizione</h2>
        <p>
          Spediamo in tutta Italia in 24/48h lavorative. La consegna è inclusa nel prezzo,
          salvo diversa indicazione al checkout.
        </p>
      </section>
      <section>
        <h2>4. Diritto di recesso</h2>
        <p>
          Hai diritto di recedere entro 15 giorni dalla data di consegna ai sensi del
          D.Lgs 206/2005. Prodotto integro, non indossato, con cartellino. Scrivici a{" "}
          <a href="mailto:info@abfeliseshop.it">info@abfeliseshop.it</a> indicando il numero
          d'ordine: ti invieremo le istruzioni per il reso e il rimborso avverrà sullo stesso
          metodo di pagamento entro 14 giorni dal rientro della merce.
        </p>
      </section>
      <section>
        <h2>5. Garanzia legale</h2>
        <p>
          Tutti i prodotti sono coperti dalla garanzia legale di conformità di 24 mesi
          (artt. 128-135 Codice del Consumo).
        </p>
      </section>
      <section>
        <h2>6. Controversie</h2>
        <p>
          Puoi risolvere eventuali controversie online tramite la piattaforma europea ODR o
          contattandoci direttamente: troveremo sempre una soluzione.
        </p>
      </section>
    </LegalLayout>
  );
}

export function ShippingPage() {
  return (
    <LegalLayout overline="Informazioni" title="Spedizioni e consegne" updated="ottobre 2026" testId="shipping-page">
      <section>
        <h2>1. Corrieri</h2>
        <p>
          Spediamo in tutta Italia con BRT, GLS, SDA o Poste Italiane, in base alla destinazione
          e alla disponibilità.
        </p>
      </section>
      <section>
        <h2>2. Tempi e costi</h2>
        <p>
          Gli ordini vengono affidati al corriere entro 24/48h lavorative dal pagamento.
          La consegna è <strong>inclusa nel prezzo</strong>, salvo diversa indicazione al checkout.
        </p>
      </section>
      <section>
        <h2>3. Tracking</h2>
        <p>
          Quando il tuo ordine parte ricevi un'email con il numero di tracking e il link per
          seguire il pacco. Lo stesso link è sempre disponibile nel tuo account, alla voce{" "}
          <strong>I miei ordini → Traccia il pacco</strong>.
        </p>
      </section>
      <section>
        <h2>4. Problemi di consegna</h2>
        <p>
          Se il pacco risulta fermo o danneggiato, scrivici subito a{" "}
          <a href="mailto:ordini@abfeliseshop.it">ordini@abfeliseshop.it</a> indicando il numero
          d'ordine: apriremo una pratica con il corriere.
        </p>
      </section>
    </LegalLayout>
  );
}

export function ReturnsPolicyPage() {
  return (
    <LegalLayout overline="Informazioni" title="Resi e rimborsi" updated="ottobre 2026" testId="returns-page">
      <section>
        <h2>1. Diritto di recesso</h2>
        <p>
          Hai diritto di recedere entro 15 giorni dalla data di consegna ai sensi del
          D.Lgs 206/2005. Prodotto integro, non indossato, con cartellino.
        </p>
      </section>
      <section>
        <h2>2. Come richiedere il reso</h2>
        <p>
          Accedi al tuo account → <strong>I miei ordini</strong> →{" "}
          <strong>Restituisci articolo/i</strong>: seleziona gli articoli, indica il motivo e invia
          la richiesta. Ti rispondiamo entro 24/48h con l'esito e le istruzioni di spedizione.
        </p>
      </section>
      <section>
        <h2>3. Rimborso</h2>
        <p>
          A rientro e controllo della merce, il rimborso parte entro 14 giorni sullo stesso metodo
          di pagamento utilizzato per l'ordine.
        </p>
      </section>
      <section>
        <h2>4. Prodotto difettoso</h2>
        <p>
          Se l'articolo arriva difettoso o danneggiato, allega una foto nella richiesta di reso:
          in questi casi le spese di rientro sono a nostro carico e vale comunque la garanzia
          legale di 24 mesi.
        </p>
      </section>
    </LegalLayout>
  );
}

export function NoteLegaliPage() {
  return (
    <LegalLayout overline="Documenti legali" title="Note Legali" updated="ottobre 2026" testId="note-legali-page">
      <section>
        <h2>Informazioni societarie (art. 2250 c.c.)</h2>
        <p>
          Titolare: Ditta Individuale ABFeliseshop di Mandalari Cristina Maria<br />
          Sede Legale: Via Mare, 62 - 89030 Condofuri (RC) - Italia<br />
          P.IVA: 03383950809<br />
          Codice Fiscale: MNDCST94E70Z140N<br />
          REA: RC-228077 - Camera di Commercio di Reggio Calabria<br />
          PEC: <a href="mailto:cristinamandalari@pec.it">cristinamandalari@pec.it</a><br />
          Email assistenza: <a href="mailto:ordini@abfeliseshop.it">ordini@abfeliseshop.it</a>
        </p>
      </section>
    </LegalLayout>
  );
}

export function AboutPage() {
  return (
    <LegalLayout overline="La nostra storia" title="Chi siamo" updated="ottobre 2026" testId="about-page">
      <section>
        <h2>AB fëlise shop</h2>
        <p>
          AB fëlise shop nasce da un'idea semplice: gli oggetti che usiamo ogni giorno meritano la
          stessa cura di quelli che ammiriamo. Per questo selezioniamo articoli per la casa —
          dispenser, borracce termiche, accessori per l'auto e piccoli alleati del quotidiano —
          testandoli uno a uno prima di metterli in vendita.
        </p>
      </section>
      <section>
        <h2>Cosa ci guida</h2>
        <p>
          Pochi articoli, ben fatti, che risolvono un problema vero. Niente cataloghi infiniti:
          ogni prodotto che vedi è quello che useremmo noi, spedito in 24/48h con reso facile
          entro 15 giorni.
        </p>
      </section>
      <section>
        <h2>Contatti</h2>
        <p>
          Informazioni e assistenza: <a href="mailto:info@abfeliseshop.it">info@abfeliseshop.it</a>
          <br />
          Ordini e spedizioni: <a href="mailto:ordini@abfeliseshop.it">ordini@abfeliseshop.it</a>
        </p>
      </section>
    </LegalLayout>
  );
}
